import { margin, maxWidth } from "@mui/system";

const styles = (theme) => ({
  cardSubText: {
    fontWeight: 500,
    fontSize: "20px",
    whiteSpace: "nowrap",
    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  containerComponent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%",
  },
  paper: {
    padding: "16px",
    display: "flex",
    flexDirection: "row",
    gap: 1,
    justifyContent: "space-between",
    minHeight: "200px",
    width: "100%",
    maxWidth: "100%",
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  containerCardData: {
    width: "30%",
    maxWidth: "100px",
    display: "flex",
    flexDirection: "column",
    margin: "15px 0 0 0",
  },
  containerCardDataTitle: {
    width: "100%",
    borderRadius: "10px 10px 0 0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "center",
    gap: 1,
    margin: "0 0 5px 0",
  },
  containerIcon: {
    borderRadius: "5px",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cardTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  containerGraph: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
  },
  icon: {
    color: theme.palette.white.main,
    fontSize: "20px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    gap: 2,
  },
});

export default styles;
